import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { api, formatApiErrorDetail } from "../../lib/api";
import { inputCls } from "../../components/forms/FormBits";
import { COMPANY } from "../../data/site";

export default function ForcePasswordReset({ onDone, onLogout }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated. Welcome!");
      onDone();
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Could not update password.");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-6 py-20" data-testid="force-reset-screen">
      <div className="w-full max-w-md rounded-2xl border border-border bg-white p-8 shadow-2xl">
        <div className="flex flex-col items-center text-center">
          <img src={COMPANY.logo} alt={COMPANY.name} className="h-14 w-14 rounded-full object-cover ring-1 ring-border" />
          <h1 className="mt-4 font-serif text-2xl text-navy">Set Your Password</h1>
          <p className="mt-1 text-sm text-muted-foreground">For your security, please change your temporary password before continuing.</p>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-4" noValidate>
          <input type="password" placeholder="Temporary / current password" className={inputCls} value={current} onChange={(e) => setCurrent(e.target.value)} data-testid="force-current-pw" />
          <input type="password" placeholder="New password" className={inputCls} value={next} onChange={(e) => setNext(e.target.value)} data-testid="force-new-pw" />
          <input type="password" placeholder="Confirm new password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="force-confirm-pw" />
          <p className="text-xs text-muted-foreground">Minimum 8 characters, with at least 3 of: lowercase, uppercase, number, symbol.</p>
          {error && <p className="text-sm font-medium text-destructive" data-testid="force-reset-error">{error}</p>}
          <button type="submit" disabled={loading} className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-navy px-6 py-3 text-sm font-semibold text-white hover:bg-navy-light disabled:opacity-70" data-testid="force-reset-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Update Password
          </button>
          <button type="button" onClick={onLogout} className="w-full text-center text-xs text-muted-foreground hover:text-navy">Sign out instead</button>
        </form>
      </div>
    </div>
  );
}
